import { filter, find, go, omit, pluck } from 'fxjs/es';
import { NewMakerEndServiceS } from '../../S/Function/module/NewMakerEndServiceS.js';
import Ups from '../../../../Ups/S/ups.js';
import { BpDiscountSetS } from '../../../../BpDiscountSet/S/Function/module/BpDiscountSetS.js';
import { NewMakerQuantityS } from '../../../Quantity/S/Function/module/NewMakerQuantityS.js';
import { BpOptionConstantS } from '../../../../BpOption/S/Constant/module/BpOptionConstantS.js';
import { $find, $qs } from 'fxdom/es';
import { getProductColorInMaker } from '../../../../Maker/F/getSth.js';
import tippy from 'tippy.js';

const listeners = [];

export const userProduct = {
  initialize: (product_color) => {
    box.set('maker->up_c', NewMakerEndServiceS.userProduct.makeUpC(product_color));
  },

  getUpUpC: () => {
    return box.sel('maker->up_c');
  },

  validator: () => {
    const product = box().maker.product_color;
    const base_product_color_id = product.base_product_color_id;
    const base_product_size_id = product.base_product_size_id;
    const base_product_id = product.base_product_id;
    const up_c = userProduct.getUpUpC();
    try {
      if (!up_c) throw new Error('up_c 없음');
      if (up_c.base_product_id !== base_product_id) throw new Error('base_product_id 다름');
      if (up_c.base_product_color_id !== base_product_color_id) throw new Error('base_product_color_id 다름');
      if (up_c.base_product_size_id !== base_product_size_id) throw new Error('base_product_size_id 다름');
      const up_c_ss = go(
        up_c._.up_c_ss,
        filter((up_c_s) => up_c_s.quantity > 0),
      );
      if (up_c_ss?.length != 1) throw new Error('up_c_ss 1개가 아님');
      const current_up_c_s = up_c_ss[0];
      if (current_up_c_s.base_product_size_id !== base_product_size_id)
        throw new Error('current_up_c_s.base_product_size_id 가 다름');
    } catch (e) {
      if (!window.ENV.is_prod) alert(e.message);
      return;
    }
    return true;
  },

  resetIfValidatorFalse: () => {
    if (!userProduct.validator()) userProduct.initialize(box().maker.product_color);
  },

  needInitializeAfterCartModal: () => {
    const up_c_ss = userProduct.getUpUpC()._.up_c_ss;
    const bps_id = getProductColorInMaker().base_product_size_id;
    const bps_ids = go(
      up_c_ss,
      filter((up_c_s) => up_c_s.quantity > 0),
      pluck('base_product_size_id'),
    );
    return bps_ids?.length > 1 || bps_ids?.length === 0 || (bps_ids?.length === 1 && bps_ids[0] !== bps_id);
  },
  updateQuantity: (quantity) => {
    const up_c_s = userProduct.findUpCS();
    up_c_s.quantity = quantity;
    userProduct.updatePrice();
  },
  stateChanged: (type) => {
    const up_c_ss_price_info = userProduct.getPriceInfo(G._en);

    listeners.forEach((l) => {
      l(up_c_ss_price_info, type);
    });
  },
  subscribe: (listener) => {
    listeners.push(listener);
  },
  findUpCS: () => {
    const up_c = userProduct.getUpUpC();
    return go(
      up_c._.up_c_ss,
      find(({ base_product_size_id }) => base_product_size_id === up_c.base_product_size_id),
    );
  },
  updateBpc: (product_color) => {
    const up_c_s = userProduct.findUpCS();
    const quantity = up_c_s.quantity || 1;
    const up_c = NewMakerEndServiceS.userProduct.makeUpC(product_color, quantity);
    Object.assign(box.sel('maker->up_c'), up_c);
    userProduct.updatePrice();
  },
  updateBps: ({ base_product_size_id }) => {
    const up_c_s = userProduct.findUpCS();
    const quantity = up_c_s.quantity;
    up_c_s.quantity = 0;
    const up_c = box.sel('maker->up_c');
    up_c.base_product_size_id = base_product_size_id;
    const new_up_c_s = userProduct.findUpCS();
    new_up_c_s.quantity = quantity || 1;
    userProduct.updatePrice();
  },
  getPriceInfo: (_en) => {
    return Ups.calc_up_c_ss_price_info(userProduct.getUpUpC()._?.up_c_ss, G._en);
  },
  updateBpOption: () => {
    const bp_discount_set = box.sel('maker->product_color->_->base_product->_->bp_discount_set');
    const bp_discount_ranges = bp_discount_set?._?.bp_discount_ranges;
    const has_bp_discount_ranges = !!bp_discount_ranges?.length;
    if (has_bp_discount_ranges) {
      const bp_discount_range = BpDiscountSetS.getBpDiscountRangeByQuantity(
        userProduct.findUpCS().quantity,
        bp_discount_ranges,
      );
      if (!bp_discount_range) {
        userProduct.initialize(box.sel('maker->product_color'));
      }
    } else {
      NewMakerEndServiceS.userProduct.updatePrice(userProduct.getUpUpC(), box.sel('maker->product_color'));
    }
    const up_c_s = userProduct.findUpCS();
    const quantity_el = $qs(`.section.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.QTY}`);
    const marpplizer_el = $qs('#marpplizer');
    let group_discount_guide_tippy_instance;
    if (marpplizer_el && marpplizer_el.__tippies?.length) {
      const btn_el = $find('.group_discount_guide', quantity_el);
      group_discount_guide_tippy_instance = marpplizer_el.__tippies.find(
        (tippy_instance) => tippy_instance.reference === btn_el,
      );
      if (group_discount_guide_tippy_instance) {
        marpplizer_el.__tippies = marpplizer_el.__tippies.filter(
          (_tippy_instance) => _tippy_instance !== group_discount_guide_tippy_instance,
        );
      }
    }
    if (quantity_el) {
      quantity_el.outerHTML = NewMakerQuantityS.makeQuantityHtml({
        qty: up_c_s.quantity,
        bp_discount_set,
        product_color: box.sel('maker->product_color'),
      });
    }
    if (group_discount_guide_tippy_instance) {
      const new_quantity_el = $qs(`.section.${BpOptionConstantS.BIZ_OPTION_MENU_KEY.QTY}`);
      const btn_el = $find('.group_discount_guide', new_quantity_el);
      marpplizer_el.__tippies.push(
        tippy(
          btn_el,
          omit(
            ['animateFill', 'followCursor', 'inlinePositioning', 'sticky'],
            group_discount_guide_tippy_instance.props,
          ),
        ),
      );
      group_discount_guide_tippy_instance.destroy();
    }
    userProduct.updatePrice();
  },
  updatePrice: () => {
    const up_c = userProduct.getUpUpC();
    if (!up_c?._?.up_c_ss?.length) return;
    NewMakerEndServiceS.userProduct.updatePrice(up_c, box.sel('maker->product_color'));
    userProduct.stateChanged();
  },
};
